"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _config = _interopRequireDefault(require("config"));

var _RegistrationField = _interopRequireDefault(require("./RegistrationField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationFieldsCollection = _backbone.default.Collection.extend({
  model: _RegistrationField.default,
  url: function url() {
    return _config.default.baseUrl + '/accounts/~';
  }
});

var _default = RegistrationFieldsCollection;
exports.default = _default;